export function AdminSidebar() {
  return (
    <aside className="admin-sidebar" aria-label="Admin navigation">
      <strong>Booply Admin</strong>
      <span>Manage Spaces</span>
      <a href="/admin">Dashboard</a>
      <a href="/pricing">Plans</a>
      <a href="/privacy-security">Privacy</a>
      <a href="/support/safety">Safety</a>
    </aside>
  );
}
